import debounce from 'lodash.debounce';

export default {

    inserted: function (el, binding) {

        let data = {
            hasFocus: false
        };

        document.addEventListener('focusin', function() {
            data.hasFocus = true;

            var focusIn = debounce(function() {
                if (data.hasFocus && getComputedStyle(el).display !== 'none' && !window.isViewport(450, true)) {
                    window.requestAnimationFrame(() => {
                        el.classList.add('is-hidden');
                    });
                } else if(el.classList.contains('is-hidden')) {
                    el.classList.remove('is-hidden');
                }

                window.removeEventListener('resize', focusIn);
            }, 100);

            window.addEventListener('resize', focusIn);
        });

        document.addEventListener('focusout', function() {
            data.hasFocus = false;

            setTimeout(function() {
                if (!data.hasFocus && getComputedStyle(el).display !== 'none') {
                    el.classList.remove('is-hidden');
                }
            }, 500);
        });

        window.addEventListener('resize', debounce(function() {
            if (!data.hasFocus && !el.classList.contains('is-hidden')) return;

            window.requestAnimationFrame(() => {
                if (!window.isViewport(450, true)) {
                    el.classList.add('is-hidden');
                } else {
                    el.classList.remove('is-hidden');
                }
            });
        }, 500));
	}

}
